export const api_url = '/api/1';
export const AUTH_URL = api_url + '/api-token-auth/';
export const AUTH_GET_TOKEN_URL = api_url + '/api-get-token-auth/';
export const CUSTOMER_URL = api_url + '/customers/';
export const CUSTOMER_REORDER_URL = api_url + '/orders/reorder/';
export const CUSTOMER_RESET_PASSWORD_URL = api_url + '/customers/reset/';
export const INGREDIENT_URL = api_url + '/ingredients/';
export const PIZZA_SAUCE_URL = api_url + '/pizzas/sauces/';
export const PIZZA_CATEGORY_URL = api_url + '/pizzas/categories/';
export const PRODUCT_CATEGORY_URL = api_url + '/categories/';
export const PRODUCT_TYPE_URL = api_url + '/types/';
export const ORDER_URL = api_url + '/orders/';
export const RESTAURANT_URL = api_url + '/restaurants/';
export const CURRENT_TIME = api_url + '/current-time/';
export const PAYMENT_ASSERT_FULL = api_url + '/payment/assert/';
export const PAYMENT_ASSERT = '/payment/assert/';
export const GOOGLE_MAP_URL = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBx3-dIRkq7MTznqRqQsC33HeJcviP1SH0&v=3.exp&libraries=geometry,drawing,places';
export const LANGUAGES = {
  'fr': 'FR',
  'en': 'EN',
  'de': 'DE'
};
export const DEFAULT_LANGUAGE = 'en';
export const LIMIT_COST_FOR_CASH = 60;
export const DEFAULT_SIZE_PIZZA = 'medium';
export const DEFAULT_ORDER_TIME = 15;
export const DEFAULT_LIFETIME_ORDER_COOKING_TIME = 2;
export const TIME_FORMAT_ORDER = 'DD/MM/YYYY h:mm a';
export const LIMIT_INGREDIENTS = 10;
export const SUBSCRIBE_URL =  api_url + '/subscribe/';



// WEBPACK FOOTER //
// ./src/constants/index.js